module.exports = __webpack_public_path__ + "static/media/login-background.879c73a8.svg";